// 本人プロフィール（GET /api/employee/me/）。氏名・所属・経営層フラグを返す。
// マイページ本体(MypageLayout)と管理画面サイドバーの入口(SidebarAccount)の両方から使う。
//
// 取得結果はモジュールに保持する。画面遷移のたびに呼び出し側が再マウントされるため、
// 初回以外は即座にキャッシュから復元して氏名のちらつきを防ぐ（notifications.js と同じ方式）。
//
// 社員レコードが無い管理者には BE が 403 を返す＝勤怠マイページを開けない。
// その場合 me は null のままで、管理画面サイドバーは入口ごと出さない。

const API_URL = process.env.REACT_APP_API_URL || "";

let cachedMe = null;
let inflight = null;

// 403（社員プロフィールが無い）が確定したら立てる。管理画面の入口はページ遷移のたびに
// 再マウントされるので、社員でない管理者に毎回403を投げ続けないための打ち切り。
let notEmployee = false;

export function getCachedMe() {
  return cachedMe;
}

export function isNotEmployee() {
  return notEmployee;
}

// 本人情報を取得。未ログイン(401)・社員でない(403)は null を返す（画面は壊さない）。
// 同時に複数箇所から呼ばれても実リクエストは1本にまとめる。
export function fetchMe() {
  if (inflight) return inflight;
  inflight = fetch(`${API_URL}/api/employee/me/`, { credentials: "include" })
    .then((res) => {
      if (res.status === 403) notEmployee = true;
      return res.ok ? res.json() : null;
    })
    .then((data) => {
      if (data) cachedMe = data;
      return data;
    })
    .catch(() => null) // 通信エラーは直近値のまま（次の再マウントで取り直す）
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
